// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"ena-z","subtitle":"fna-z","wrapper":"gna-z","leftArrow":"hna-z","rightArrow":"ina-z"};